import '../assets/NcCheckboxRadioSwitch-D0kAZROF.css';
import { r as register } from "./_l10n-DXr-EzLn.mjs";
register();
